import axios from "axios";

export class ResendConfirmationComponent {
    constructor() {}

    private input = document.querySelector<HTMLInputElement>('#email');
    private emailModal = document.getElementById('email-booking-modal');
    private errorMsgSpan = document.querySelector<HTMLSpanElement>('.error-msg');
    private modalContent = document.getElementById('resend-modal-content');

    public onSendConfirmationLinkClick = (e: Event) => {
        const target = e.target as HTMLButtonElement | HTMLAnchorElement;

        if (target && (target.nodeName === "BUTTON" || target.nodeName === "A")) {
            if (target.classList.contains("show-email-modal")) {
              this.modalContent.classList.remove('success');
              this.input.classList.remove('invalid');
              this.input.value = '';
              this.emailModal.style.display = 'flex';
            }
        }
    }

    public onModalClick = (e: Event) => {
        const target = e.target as HTMLElement;

        if (target.classList.contains("overlay") || target.classList.contains("btn-cancel")
            || target.classList.contains("zmdi-close")) {
          this.emailModal.style.display = 'none';
        }
    }

    public onResendClick = (e: Event) => {          
        const val = this.input.value;

        if (!val) {
          this.input.classList.add('invalid');
          this.errorMsgSpan.textContent = 'Email address is required.';
          return;
        }

        this.input.classList.remove('invalid');
        this.emailModal.classList.add('loading');
        const resendUrl = document.querySelector('#email-booking-modal [data-resend-url]').getAttribute('data-resend-url');
        const bookingUrl = document.querySelector('#email-booking-modal [data-bookingurl]').getAttribute('data-bookingurl');
        const sitekey = document.querySelector('#email-booking-modal [data-sitekey]').getAttribute('data-sitekey');

        if (sitekey && sitekey.length > 0) {
          grecaptcha.ready(() => {
            grecaptcha.execute(sitekey, { action: 'submit' }).then((token) => {
                axios.post(resendUrl, {
                    emailAddress: val,
                    bookingUrlId: bookingUrl,
                    recaptchaToken: token
                  }, {
                    withCredentials: true
                })
                .then(() => {
                  this.modalContent.classList.add('success');
                })
                .catch((error: any) => {
                  const msg = error?.response?.data['EmailAddress'];
                  this.errorMsgSpan.textContent = msg ? msg : 'Something went wrong. Please try again.';
                  this.input.classList.add('invalid');
                })
                .finally(() => {
                  this.emailModal.classList.remove('loading');
                });
              });
          });
        }
        else {
          axios.post(resendUrl, {
              emailAddress: val,
              bookingUrlId: bookingUrl,
              recaptchaToken: ''
            }, {
              withCredentials: true
          })
          .then(() => {
            this.modalContent.classList.add('success');
          })
          .catch((error: any) => {
            const msg = error?.response?.data['EmailAddress'];
            this.errorMsgSpan.textContent = msg ? msg : 'Something went wrong. Please try again.';
            this.input.classList.add('invalid');
          })
          .finally(() => {
            this.emailModal.classList.remove('loading');
          });
        }
      }
}